import {Component, Input, OnInit} from '@angular/core';
import {PropertyLineModel} from '../../../properties/models/property-line.model';
import {GLOBAL} from 'common-shared';
import {PropertyService} from '../../../properties/property.service';
import {ClassificatorValuesQuery} from 'common-shared';

@Component({
  selector: 'mes-web-property-line-view',
  templateUrl: './property-line-view.component.html'
})
export class PropertyLineViewComponent implements OnInit {

  @Input() propertyLine: PropertyLineModel;

  propertyTypes = GLOBAL.Classificators.PropertyType;

  constructor(public propertyService: PropertyService, public classificatorValueService: ClassificatorValuesQuery) { }

  ngOnInit() {
  }
}
